import { render, staticRenderFns } from "./RadioInputCustom.vue?vue&type=template&id=4f5a235b&scoped=true&"
import script from "./RadioInputCustom.vue?vue&type=script&lang=js&"
export * from "./RadioInputCustom.vue?vue&type=script&lang=js&"
import style0 from "./RadioInputCustom.vue?vue&type=style&index=0&id=4f5a235b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a235b",
  null
  
)

export default component.exports